import { ActionFunction, redirect } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// GQL
import { client } from '../../../gql/client';
import { VALIDATE_USER } from '../../../gql/mutations/auth';
import i18n from '../../../i18n';

// Type
import { AuthContextType } from '../../../hooks/useAuth';
import { getSessionStorageUser } from '../../../utils/sessionStorage';
import { offerToSaveCredentials } from '../../../utils/savedCredentials';

export const ActionResetPassword: (
  userData: AuthContextType | null
) => ActionFunction | undefined = (userData) => async (formDataRaw) => {
  const formData = Object.fromEntries(await formDataRaw.request.formData());

  const userId =
    userData?.user?.user?.id ?? getSessionStorageUser()?.user?.id;

  try {
    const {
      data: { validateUser },
    } = await client.mutate({
      mutation: VALIDATE_USER,
      variables: {
        input: {
          id: userId,
          newPassword: formData.newPassword,
        },
      },
    });

    userData?.setUser({
      ...userData?.user,
      user: {
        ...userData?.user?.user,
        validated: validateUser.validated,
      },
    });

    // El otro punto donde se conoce una contraseña que el backend da por buena.
    //
    // El login se salta a propósito al usuario sin validar, porque su
    // contraseña está a punto de dejar de servir: es AQUÍ donde acaba de
    // elegir la definitiva, y por tanto la que merece guardarse.
    const email =
      userData?.user?.user?.email ?? getSessionStorageUser()?.user?.email;
    if (email) {
      offerToSaveCredentials(String(email), String(formData.newPassword));
    }

    return redirect('/');
  } catch (err) {
    Sentry.captureException(err);
    console.log('[auth] error restableciendo la contraseña', err);
  }

  return null;
};
